import React, {useState} from "react"
import styled from "styled-components"

import {SchedulerEvent} from "@irati/types"
import {MutationFn} from "@irati/utils/apollo"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"
import Flex from "@irati/ui/src/Flex"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {useIntl} from "@irati/utils/lang"
import ArchiveRecognitionMutation from "@irati/recognition/apollo/mutation/Recognition/Archive"
import recognitionErrorHandler from "@irati/recognition/services/errors/recognitionErrorHandler"
import RecognitionActions from "../Popup/ScheduledRecognition/Actions"
import {ConfirmRemoveScheduledRecognition} from "../Popup/shared/styled"
import ScheduledRecognitionAddReward from "./ScheduledRecognitionAddReward"

const ActionsWrapper = styled.div`
  position: relative;
`
interface Props {
  item: SchedulerEvent
  feedItemId?: string
  viewRecognition: () => void
}

const Activity: React.FC<Props> = (props) => {
  const {item, viewRecognition} = props
  const [isDeleteMode, setIsDeleteMode] = useState(false)
  const theme = useTheme()
  const intl = useIntl()
  const onClickRemove = () => setIsDeleteMode(true)
  const onArchived = () => {
    setIsDeleteMode(false)
  }
  return (
    <Flex alignItems="center" gap={theme.spacing.oneAndHalf}>
      <ScheduledRecognitionAddReward item={item} viewRecognition={viewRecognition} />
      <ActionsWrapper>
        <RecognitionActions recognition={item} onClickRemove={onClickRemove} viewRecognition={viewRecognition} />
        {isDeleteMode && (
          <ArchiveRecognitionMutation recognition={item} onCompleted={onArchived}>
            {(mutate: MutationFn, apolloState: ApolloState) => (
              <ConfirmRemoveScheduledRecognition
                apolloState={{...apolloState, errorMsg: intl.formatMessage({id: recognitionErrorHandler(apolloState.error)})}}
                onCancel={() => setIsDeleteMode(false)}
                onConfirm={mutate}
              />
            )}
          </ArchiveRecognitionMutation>
        )}
      </ActionsWrapper>
    </Flex>
  )
}

export default Activity
